export const questionsNumber = 22;